<template>
  <CCard v-if="!bare">
    <CCardHeader class="border-0 px-4 pb-1 pt-4">
      <div class="d-flex align-items-center font-weight-medium">
        <CIcon name="cipGridSm" size="custom-size" :width="18" class="mr-2"/>
        <translate translate-context="accounting.refund">Ledger entries</translate>
      </div>
    </CCardHeader>
    <CCardBody>
      <LedgerEntriesTableBody :entries="entries"/>
    </CCardBody>
  </CCard>
  <LedgerEntriesTableBody v-else :entries="entries"/>
</template>

<script>
import LedgerEntriesTableBody from './LedgerEntriesTableBody.vue'

export default {
  name: 'LedgerEntriesTable',
  components: {LedgerEntriesTableBody},
  props: {
    entries: {
      type: Array,
      default: () => []
    },
    bare: {
      type: Boolean,
      default: false
    }
  }
}
</script>
